export function formatMinutes(minutesInput: number): string {
  const hours = Math.floor(minutesInput / 60);
  const minutes = minutesInput % 60;

  return `${hours} Std. und ${minutes} Min.`;
}
